import * as Yup from 'yup';

const insuranceNetworkSchema = Yup.object().shape({
  name: Yup.string().required('Name cannot be left blank')
});

export default insuranceNetworkSchema;
